import { NotificationsByCustomerIdQuery, NotificationsDismissMutation, GetToken } from '@water-web/api';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const NotificationsServiceConstructor = (config: { baseUrl: string; getToken: GetToken }) => ({
  getByCustomerId: new NotificationsByCustomerIdQuery(config),
  dismiss: new NotificationsDismissMutation(config),
});
